var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show())?_c('div',{staticClass:"brackets__shuffle-button"},[_c('button',{staticClass:"button",on:{"click":function($event){$event.preventDefault();return _vm.shuffle.apply(null, arguments)}}},[_c('SvgIcon',{attrs:{"width":"24","height":"24","iconType":'shuffle'}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }